import { render, staticRenderFns } from "./CompareProjectCostsTable.vue?vue&type=template&id=0bdc4432&scoped=true&"
import script from "./CompareProjectCostsTable.vue?vue&type=script&lang=js&"
export * from "./CompareProjectCostsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdc4432",
  null
  
)

export default component.exports